import React from "react";
import NumberFormat from "react-number-format";

export default class CurrencyFormatInput extends React.Component {
  rejectValue(values) {
    const { floatValue, value } = values;

    const { allowZero, max, min } = this.props;
    if (value && floatValue) {
      if (max || min) {
        return (!max || floatValue <= max) && (!min || floatValue >= min);
      }
    } else if (floatValue === 0 && (!allowZero || min > 0)) {
      return false;
    }
    
    return true;
  }

  onChange(e) {
    const event = { ...e };
    event.target.value = event.target.value.replace(/[^0-9\.-]/g, "");
    this.props.onChange(event);
  }

  render() {
    const {
      allowNegative,
      allowZero,
      isIsraeli,
      onChange,
      max,
      min,
      ...passProps
    } = this.props;

    return (
      <div className="dollar-input">
        {isIsraeli ? (
          <i className="material-icons shekel-icon">₪</i>
        ) : (
          <i className="material-icons">attach_money</i>
        )}
        <NumberFormat
          {...passProps}
          allowNegative={allowNegative || false}
          decimalScale={2}
          isAllowed={this.rejectValue.bind(this)}
          onChange={this.onChange.bind(this)}
          thousandSeparator={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/commonComponents/util/CurrencyFormatInput.jsx